/** True, wenn Pfad und die in `route` gesetzten Query-Parameter zur Location passen. */
export function locationMatchesRoute(
  pathname: string,
  search: string,
  route: string | null,
): boolean {
  if (!route) return true;
  const url = new URL(route, "http://local");
  if (pathname !== url.pathname) return false;
  if (!url.search) return true;
  const have = new URLSearchParams(search);
  for (const [key, value] of url.searchParams) {
    if (have.get(key) !== value) return false;
  }
  return true;
}
